// Development mode localStorage storage layer
// Used as a fallback when window.electronAPI is not available

class DevStorage {
  static getDevStorage() {
    const data = localStorage.getItem('pigeonPedigreeData');
    const parsed = data ? JSON.parse(data) : { birds: [], settings: {}, raceResults: [], charts: [], chartRaces: [], chartBirds: [], diaryEntries: [], nextId: 1 };
    if (!Array.isArray(parsed.raceResults)) parsed.raceResults = [];
    if (!Array.isArray(parsed.charts)) parsed.charts = [];
    if (!Array.isArray(parsed.chartRaces)) parsed.chartRaces = [];
    if (!Array.isArray(parsed.chartBirds)) parsed.chartBirds = [];
    if (!Array.isArray(parsed.diaryEntries)) parsed.diaryEntries = [];
    // One-time migration: remove autogenerated placeholder names like "Bird N"
    try {
      parsed.migrations = parsed.migrations || {};
      if (!parsed.migrations.placeholderNamesCleaned) {
        const before = JSON.stringify(parsed.birds);
        const placeholderRegex = /^bird\s+\d+$/i;
        parsed.birds = (parsed.birds || []).map(b => ({
          ...b,
          name: (typeof b.name === 'string' && placeholderRegex.test(b.name.trim())) ? '' : (b.name || '')
        }));
        parsed.migrations.placeholderNamesCleaned = true;
        localStorage.setItem('pigeonPedigreeData', JSON.stringify(parsed));
      }
    } catch (e) {
      console.warn('Placeholder name cleanup migration skipped:', e);
    }
    // Sanitize birds: normalize ids and parent refs to numbers; ensure timestamps
    try {
      const birds = Array.isArray(parsed.birds) ? parsed.birds : [];
      let changed = false;
      parsed.birds = birds.map(b => {
        const nb = { ...b };
        const orig = JSON.stringify(nb);
        if (nb.id != null) nb.id = Number(nb.id);
        const norm = (v) => {
          if (v === undefined || v === null) return null;
          if (typeof v === 'string' && v.trim() === '') return null;
          const n = Number(v);
          return Number.isFinite(n) && n > 0 ? n : null;
        };
        nb.sire_id = norm(nb.sire_id);
        nb.dam_id = norm(nb.dam_id);
        if (!nb.created_at) nb.created_at = new Date().toISOString();
        if (!nb.updated_at) nb.updated_at = nb.created_at;
        if (orig !== JSON.stringify(nb)) changed = true;
        return nb;
      });
      if (changed) {
        localStorage.setItem('pigeonPedigreeData', JSON.stringify(parsed));
      }
    } catch (e) {
      console.warn('Dev storage sanitize skipped:', e);
    }
    return parsed;
  }

  static setDevStorage(data) {
    localStorage.setItem('pigeonPedigreeData', JSON.stringify(data));
  }
}

export default DevStorage;
